export default __webpack_public_path__ + "static/icecream-taste-1-desktop-6a92e0a767026a6930af0d505545847f.png";